/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
import Owl from '../vendors/owl.carousel.min';
import GSAP from '../vendors/gsap.min.js';
import ScrollTrigger from '../vendors/scrollTrigger.min.js';

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 20 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

/**
 * CTA Light Box
 */

jQuery.fn.ctaPopup = function() {
	return this.each( function() {
		const element = jQuery( this );

		if ( typeof setWithExpiry !== 'undefined' ) {
			const ctaPopupClosed = getWithExpiry( 'ctaPopupClosed' );
			if ( ctaPopupClosed === null ) {
				jQuery( 'body' ).addClass( 'have-cta-banner' );
				jQuery.magnificPopup.open( {
					items: {
						src: '#cta-popup',
					},
					type: 'inline',
					closeBtnInside: true,
					mainClass: 'mfp-fade cta-popup-ctn',
					removalDelay: 300,
					closeOnBgClick: false,
					callbacks: {
						close() {
							setWithExpiry( 'ctaPopupClosed', 'closed', 0, 86400 * 60 * 24 ); // 1 Day
						},
					},
				} );
			} else {
				jQuery( 'body' ).removeClass( 'have-cta-banner' );
			}
		} else {
			console.log(
				'Please add the local-data dependency for the code to work fully -> topbar lib'
			);
		}

		function getWithExpiry( key ) {
			const itemStr = localStorage.getItem( key );
			if ( ! itemStr ) {
				return null;
			}
			const item = JSON.parse( itemStr );
			const now = new Date();
			if ( now.getTime() > item.expiry ) {
				localStorage.removeItem( key );
				return null;
			}
			return item;
		}

		function setWithExpiry( key, value, discount = 0, ttl ) {
			const now = new Date();
			const item = {
				value,
				discount,
				expiry: now.getTime() + ttl,
			};
			localStorage.setItem( key, JSON.stringify( item ) );
		}
	} );
};

/**
 * HomePage Takeover Banner
 */

jQuery.fn.takeoverBanner = function() {
	return this.each( function() {
		const element = jQuery( this );

		if ( typeof setWithExpiry !== 'undefined' ) {
			const takeoverBanner = getWithExpiry( 'takeoverBanner' );
			if ( takeoverBanner === null ) {
				jQuery( 'body' ).addClass( 'show-take-over-banner' );
				jQuery( 'body' ).removeClass( 'hide-take-over-banner' );
				element.show();
			} else {
				jQuery( 'body' ).removeClass( 'show-take-over-banner' );
				jQuery( 'body' ).addClass( 'hide-take-over-banner' );
				element.hide(); // Use hide() instead of fadeOut() for instant hiding
			}
		} else {
			console.log(
				'Please add the local-data dependency for the code to work fully -> topbar lib'
			);
		}

		element.find( '.takeover-close-button' ).click( function() {
			element.hide(); // Use hide() instead of fadeOut() for instant hiding
			jQuery( this ).parents().find( 'body' ).removeClass( 'take-over-banner' );
			if ( typeof setWithExpiry !== 'undefined' ) {
				setWithExpiry( 'takeoverBanner', 'closed', 0, 86400 * 60 * 24 ); // 1 Day
			}
		} );

		function getWithExpiry( key ) {
			const itemStr = localStorage.getItem( key );
			if ( ! itemStr ) {
				return null;
			}
			const item = JSON.parse( itemStr );
			const now = new Date();
			if ( now.getTime() > item.expiry ) {
				localStorage.removeItem( key );
				return null;
			}
			return item;
		}

		function setWithExpiry( key, value, discount = 0, ttl ) {
			const now = new Date();
			const item = {
				value,
				discount,
				expiry: now.getTime() + ttl,
			};
			localStorage.setItem( key, JSON.stringify( item ) );
		}
	} );
};

/**
 * Border Bottom
 */
jQuery( window ).scroll( function() {
	const loc_nav_height =
			jQuery( '.hero' ).outerHeight() + 82;
	if ( jQuery( window ).scrollTop() >= loc_nav_height ) {
		jQuery( '.sticky-nav' ).addClass( 'sticky-nav-border' );
	} else {
		jQuery( '.sticky-nav' ).removeClass( 'sticky-nav-border' );
	}
} );
/**
 * MidPage Cta Height
 */
if ( jQuery( window ).width() > 1003 ) {
	jQuery( function( $ ) {
		const $leftHeight = jQuery( '.mid-page-cta__left' ).outerHeight();
		const $rightHeight = jQuery( '.mid-page-cta__right' );
		$rightHeight.css( 'height', $leftHeight + 'px' );
	} );
}

jQuery( function() {
	// TimeLine
	function runTimelineScript() {
		if ( jQuery( window ).width() > 1003 ) {
			if ( jQuery( '.timeline' ).length > 0 ) {
				const timelineContentBoxes = document.querySelectorAll( '.timeline__content-box' );
				const timelineRightOuterHeight = jQuery( '.timeline__right' ).outerHeight() - 1000;

				timelineContentBoxes.forEach( ( item, index ) => {
					const dataCountValue = item.getAttribute( 'id' );
					const relatedImage = document.querySelector( `[data-count="${ dataCountValue }"]` );

					gsap.to( item, {
						scrollTrigger: {
							trigger: item,
							start: 'top 25%',
							endTrigger: '.timeline-clear',
							end: `bottom top+=550`,
							scrub: true,
							pin: false,
							onEnter: () => {
								item.classList.add( 'active' );
								if ( relatedImage ) {
									relatedImage.classList.add( 'active' );
								}
							},
							onLeaveBack: () => {
								item.classList.remove( 'active' );
								if ( relatedImage ) {
									relatedImage.classList.remove( 'active' );
								}
							},
						},
						duration: 1,
					} );
				} );
			}
		}
	}

	// Initial run
	runTimelineScript();

	// Run the script on window resize
	window.addEventListener( 'resize', () => {
		runTimelineScript();
	} );

	jQuery( '.virtual-model-slider' ).owlCarousel( {
		margin: 12,
		loop: false,
		nav: true,
		dots: false,
		items: 1,
	} );

	if ( jQuery( '#virtual-map-svg' ).length > 0 ) {
		// const virtualMap = svgPanZoom( '#virtual-map-svg', {
		// 	zoomEnabled: true,
		// 	controlIconsEnabled: false,
		// 	mouseWheelZoomEnabled: true,
		// 	fit: false,
		// 	center: true,
		// 	minZoom: 0.1,
		// 	contain: true,
		// } );
		// jQuery( document ).on( 'click', '#zoom-in', function() {
		// 	virtualMap.zoomIn();
		// } );
		// jQuery( document ).on( 'click', '#zoom-out', function() {
		// 	virtualMap.zoomOut();
		// } );
		// setTimeout( () => {
		// 	if ( jQuery( window ).width() < 747 ) {
		// 		virtualMap.zoom( 2 );
		// 		virtualMap.pan( { x: -300, y: -450 } );
		// 	}
		// }, 2000 );

		jQuery( '.close-icon' ).on( 'click', function() {
		// Remove 'active' class from the parent div with class 'virtual-model'
			jQuery( this ).closest( '.virtual-model' ).removeClass( 'active' );
			jQuery( '#icons' ).removeClass( 'active-map' );
		} );
		jQuery( document ).on( 'click touchstart', '.map-pin', function() {
			jQuery( '.virtual-model' ).removeClass( 'active' );
			jQuery( '.virtual-model[data-id="' + jQuery( this ).attr( 'id' ) + '"]' ).addClass( 'active' );
			jQuery( '.map-pin' ).removeClass( 'active-pin' );

			jQuery( this ).addClass( 'active-pin' );
			if ( jQuery( this ).hasClass( 'active-pin' ) ) {
				jQuery( this ).parents( '#icons' ).addClass( 'active-map' );
			} else {
				jQuery( this ).parents( '#icons' ).removeClass( 'active-map' );
			}
			// const elem = jQuery( this );
			// const position = jQuery( elem ).offset();
			// const parentOffset = jQuery( '#virtual-map-svg' ).offset();

			// position.top -= parentOffset.top;
			// position.left -= parentOffset.left;
			// const width = jQuery( '#virtual-map-svg' ).width();
			// const height = jQuery( '#virtual-map-svg' ).height();
			// virtualMap.resetZoom();
			// virtualMap.resetPan();
			// virtualMap.panBy( { x: width / 2 - position.left, y: height / 2 - position.top } );
		} );
		jQuery( document ).on( 'click', '.reset-map', function() {
			virtualMap.resetZoom();
			virtualMap.resetPan();
		} );

		jQuery( document ).on( 'click', '.prev-button,.next-button,.map-related', function() {
			//jQuery( '.map-pin[id="' + jQuery( this ).attr( 'data-id' ) + '"]' ).trigger( 'click' );

			jQuery( '.virtual-model' ).removeClass( 'active' );
			jQuery( '.virtual-model[data-id="' + jQuery( this ).attr( 'data-id' ) + '"]' ).addClass( 'active' );
			jQuery( '.map-pin' ).removeClass( 'active-pin' );

			jQuery( '.map-pin[id="' + jQuery( this ).attr( 'data-id' ) + '"]' ).addClass( 'active-pin' );
			if ( jQuery( '.map-pin[id="' + jQuery( this ).attr( 'data-id' ) + '"]' ).hasClass( 'active-pin' ) ) {
				jQuery( '.map-pin[id="' + jQuery( this ).attr( 'data-id' ) + '"]' ).parents( '#icons' ).addClass( 'active-map' );
			} else {
				jQuery( '.map-pin[id="' + jQuery( this ).attr( 'data-id' ) + '"]' ).parents( '#icons' ).removeClass( 'active-map' );
			}

			jQuery( '.virtual-model-image' ).find( 'video' ).trigger( 'pause' );
		} );

		jQuery( document ).on( 'click', '.close-icon', function() {
			jQuery( '.virtual-model-image' ).find( 'video' ).trigger( 'pause' );
		} );
	}

	// Perfect Wp-images

	const extLink = jQuery( 'body a' ).filter( function() {
		return this.hostname && this.hostname !== location.hostname;
	} );
	extLink.each( function() {
		jQuery( this ).attr( 'target', '_blank' );
		jQuery( this ).addClass( 'external-link' );
	} );

	/**
	 * Team Popup
	 */
	let currentPopupId = null;

	function closePopup() {
		jQuery( '.team-members-popup, body' ).removeClass( 'show' );
		if ( currentPopupId ) {
			jQuery( currentPopupId ).removeClass( 'team-show' );
		}
		currentPopupId = null;
		jQuery( 'html' ).css( 'overflow-y', 'auto' );
		jQuery( 'html' ).css( 'margin-right', '0' );
	}

	// Attach click event to '.team-members__single' elements
	jQuery( '.team-members__single' ).on( 'click', function() {
		const id = jQuery( this ).attr( 'href' );
		if ( currentPopupId ) {
			jQuery( currentPopupId ).removeClass( 'team-show' );
		}
		jQuery( '.team-members-popup, body' ).addClass( 'show' );
		jQuery( id ).addClass( 'team-show' );
		currentPopupId = id;
		jQuery( 'html' ).css( 'overflow-y', 'hidden' );
		jQuery( 'html' ).css( 'margin-right', '16px' );
	} );

	// Attach click event to '.popup-close-button' elements
	jQuery( '.popup-close-button' ).on( 'click', function() {
		closePopup();
	} );

	// Attach click event to 'body' to close popup when clicking outside
	jQuery( 'body' ).on( 'click', function( event ) {
		if (
			! jQuery( event.target ).closest( '.team-members-popup' ).length &&
        ! jQuery( event.target ).closest( '.team-members__single' ).length
		) {
			closePopup();
		}
	} );

	/**
	 * Chimp Teaser
	 */
	if ( jQuery( window ).width() > 1180 ) {
		jQuery( window ).on( 'load', function() {
			jQuery( document ).on( 'click', '#shuffleButton', function() {
				const items = [];
				let suffle_items = [];

				jQuery( '.chimp-teaser__items__list' ).find( '.chimp-teaser__singe-item' ).each( function( i, v ) {
					items.push( jQuery( this ) );
				} );

				suffle_items = randomArrayShuffle( items );

				// Add 'random-effect' class to .chimp-teaser__items__list
				jQuery( '.chimp-teaser__items__list' ).addClass( 'random-effect' );

				// Toggle the 'new-list-class' on each click
				jQuery( '.chimp-teaser__items__list' ).toggleClass( 'new-items' );

				// Clear the content of .chimp-teaser__items__list
				jQuery( '.chimp-teaser__items__list' ).html( '' );

				jQuery( suffle_items ).each( function( i ) {
					const delay = i * 0;
					const fadeInDuration = 800;

					jQuery( this ).css( {
						opacity: 0,
					} );

					jQuery( '.chimp-teaser__items__list' ).append( jQuery( this ) );

					if ( i < 4 ) {
						// Add a class to the first four items
						jQuery( '.fixed-item:nth-child(1)' ).css( 'top', '48' );
						jQuery( this ).addClass( 'fixed-item' );
						jQuery( this ).removeClass( 'no-fixed-item' );

						jQuery( this ).delay( delay ).animate( {
							opacity: 1,
						}, fadeInDuration );
					} else {
						// Add a class to items beyond the first four
						jQuery( this ).addClass( 'no-fixed-item' );
						jQuery( this ).removeClass( 'fixed-item' );

						jQuery( this ).show();
					}
				} );
			} );

			function randomArrayShuffle( array ) {
				let currentIndex = array.length,
					temporaryValue, randomIndex;

				while ( 0 !== currentIndex ) {
					randomIndex = Math.floor( Math.random() * currentIndex );
					currentIndex -= 1;
					temporaryValue = array[ currentIndex ];
					array[ currentIndex ] = array[ randomIndex ];
					array[ randomIndex ] = temporaryValue;
				}

				return array;
			}
		} );
	}
	if ( jQuery( window ).width() < 1180 ) {
		jQuery( window ).on( 'load', function() {
			jQuery( document ).on( 'click', '#shuffleButton', function() {
				const items = [];
				let suffle_items = [];

				jQuery( '.chimp-teaser__items__list' ).find( '.chimp-teaser__singe-item' ).each( function( i, v ) {
					items.push( jQuery( this ) );
				} );

				suffle_items = randomArrayShuffle( items );

				// Add 'random-effect' class to .chimp-teaser__items__list
				jQuery( '.chimp-teaser__items__list' ).addClass( 'random-effect' );

				// Toggle the 'new-list-class' on each click
				jQuery( '.chimp-teaser__items__list' ).toggleClass( 'new-items' );

				// Clear the content of .chimp-teaser__items__list
				jQuery( '.chimp-teaser__items__list' ).html( '' );

				jQuery( suffle_items ).each( function( i ) {
					const delay = i * 150;
					const fadeInDuration = 150;

					jQuery( this ).css( {
						opacity: 0,
					} );

					jQuery( '.chimp-teaser__items__list' ).append( jQuery( this ) );

					if ( i < 3 ) {
						// Add a class to the first four items
						jQuery( this ).addClass( 'fixed-item' );
						jQuery( this ).removeClass( 'no-fixed-item' );

						jQuery( this ).delay( delay ).animate( {
							opacity: 1,
						}, fadeInDuration );
					} else {
						// Add a class to items beyond the first four
						jQuery( this ).addClass( 'no-fixed-item' );
						jQuery( this ).removeClass( 'fixed-item' );

						jQuery( this ).show();
					}
				} );
			} );

			function randomArrayShuffle( array ) {
				let currentIndex = array.length,
					temporaryValue, randomIndex;

				while ( 0 !== currentIndex ) {
					randomIndex = Math.floor( Math.random() * currentIndex );
					currentIndex -= 1;
					temporaryValue = array[ currentIndex ];
					array[ currentIndex ] = array[ randomIndex ];
					array[ randomIndex ] = temporaryValue;
				}

				return array;
			}
		} );
	}
	if ( jQuery( window ).width() < 748 ) {
		jQuery( window ).on( 'load', function() {
			jQuery( document ).on( 'click', '#shuffleButton', function() {
				const items = [];
				let suffle_items = [];

				jQuery( '.chimp-teaser__items__list' ).find( '.chimp-teaser__singe-item' ).each( function( i, v ) {
					items.push( jQuery( this ) );
				} );

				suffle_items = randomArrayShuffle( items );

				// Add 'random-effect' class to .chimp-teaser__items__list
				jQuery( '.chimp-teaser__items__list' ).addClass( 'random-effect' );

				// Toggle the 'new-list-class' on each click
				jQuery( '.chimp-teaser__items__list' ).toggleClass( 'new-items' );

				// Clear the content of .chimp-teaser__items__list
				jQuery( '.chimp-teaser__items__list' ).html( '' );

				jQuery( suffle_items ).each( function( i ) {
					const delay = i * 150;
					const fadeInDuration = 150;

					jQuery( this ).css( {
						opacity: 0,
					} );

					jQuery( '.chimp-teaser__items__list' ).append( jQuery( this ) );

					if ( i < 2 ) {
						// Add a class to the first four items
						jQuery( this ).addClass( 'fixed-item' );
						jQuery( this ).removeClass( 'no-fixed-item' );

						jQuery( this ).delay( delay ).animate( {
							opacity: 1,
						}, fadeInDuration );
					} else {
						// Add a class to items beyond the first four
						jQuery( this ).addClass( 'no-fixed-item' );
						jQuery( this ).removeClass( 'fixed-item' );

						jQuery( this ).show();
					}
				} );
			} );

			function randomArrayShuffle( array ) {
				let currentIndex = array.length,
					temporaryValue, randomIndex;

				while ( 0 !== currentIndex ) {
					randomIndex = Math.floor( Math.random() * currentIndex );
					currentIndex -= 1;
					temporaryValue = array[ currentIndex ];
					array[ currentIndex ] = array[ randomIndex ];
					array[ randomIndex ] = temporaryValue;
				}

				return array;
			}
		} );
	}

	/**
	 * Break Script
	 */
	if ( jQuery( window ).width() < 747 ) {
		const array = [];
		let html = '';

		jQuery( '.icon-grid.standard' ).find( '.icon-grid__detail-boxes' ).find( '.icon-grid__detail' ).each( function() {
			array.push( '<div class="icon-grid__detail">' + jQuery( this ).html() + '</div>' );
		} );

		html += array.join( '' );

		jQuery( '.icon-grid.standard .icon-grid__detail-boxes' ).html( html );
	}

	/**
	 * Stats College
	 */
	if ( jQuery( window ).width() > 1004 ) {
		if ( jQuery( '.stat-collage' ).length > 0 ) {
			jQuery( '.expand-left' ).on( 'click', function() {
				// Add the class on click
				jQuery( '.expand-left' ).addClass( 'expand-height' );

				jQuery( '.expand-right' ).css( {
					opacity: '0',
					right: '-1%',
					width: '0',

				} );

				jQuery( '.expand-left' ).css( {
					width: '100%',
				} );

				jQuery( '.video-close' ).css( {
					display: 'block',
				} );

				jQuery( '.stat-long-video' ).css( {
					display: 'block',
				} );

				jQuery( '.video-button' ).css( {
					display: 'block',
				} );

				jQuery( '.stat-collage__short-video' ).css( {
					display: 'none',
				} );

				jQuery( '.play-button.with-text' ).css( {
					display: 'none',
				} );
			} );

			jQuery( document ).on( 'click', '.video-close', function() {
				jQuery( '.expand-left' ).removeClass( 'expand-height' );

				jQuery( '.stat-collage__short-video' ).css( {
					display: 'block',
				} );
				jQuery( '.stat-long-video' ).css( {
					display: 'none',
				} );
				jQuery( '.video-close' ).css( {
					display: 'none',
				} );

				jQuery( '.expand-right' ).css( {
					width: '41.9%',
					opacity: '1',
					right: '0',

				} );

				jQuery( '.expand-left' ).css( {
					width: '56.8%',
				} );
				setTimeout( () => {
					jQuery( '.play-button.with-text' ).css( {
						display: 'flex',
					} );
					jQuery( '.play-button.video-button' ).css( {
						display: 'none',
					} );
				}, 1200 );
			} );
		}
	}
	if ( jQuery( window ).width() < 1004 ) {
		if ( jQuery( '.stat-collage' ).length > 0 ) {
			jQuery( '.expand-left' ).on( 'click', function() {
				// Add the class on click
				jQuery( '.expand-left' ).addClass( 'expand-height' );

				jQuery( '.expand-right' ).css( {
					opacity: '1',
					right: '0%',
					width: '100%',

				} );

				jQuery( '.expand-left' ).css( {
					width: '100%',
				} );

				jQuery( '.video-close' ).css( {
					display: 'block',
				} );

				jQuery( '.stat-long-video' ).css( {
					display: 'block',
				} );

				jQuery( '.video-button' ).css( {
					display: 'block',
				} );

				jQuery( '.stat-collage__short-video' ).css( {
					display: 'none',
				} );

				jQuery( '.play-button.with-text' ).css( {
					display: 'none',
				} );
			} );

			jQuery( document ).on( 'click', '.video-close', function() {
				jQuery( '.expand-left' ).removeClass( 'expand-height' );

				jQuery( '.stat-collage__short-video' ).css( {
					display: 'block',
				} );
				jQuery( '.stat-long-video' ).css( {
					display: 'none',
				} );
				jQuery( '.video-close' ).css( {
					display: 'none',
				} );

				jQuery( '.expand-right' ).css( {
					width: '100%',
					opacity: '1',
					right: '0',

				} );

				jQuery( '.expand-left' ).css( {
					width: '100%',
				} );
				setTimeout( () => {
					jQuery( '.play-button.with-text' ).css( {
						display: 'flex',
					} );
					jQuery( '.play-button.video-button' ).css( {
						display: 'none',
					} );
				}, 1200 );
			} );
		}
	}

	 if ( jQuery( window ).width() > 748 ) {
		const video = jQuery( '#myVideo' );
		const playButton = jQuery( '.video-button,.stat-collage__short-video' );

		playButton.on( 'click', togglePlayPause );
		function togglePlayPause() {
			if ( video[ 0 ].paused ) {
				video[ 0 ].play();
			} else {
				video[ 0 ].pause();
			}
		}
		function stopVideo() {
			video[ 0 ].pause();
		}
	}

	if ( jQuery( window ).width() < 748 ) {
		const video = jQuery( '#myVideo' );
		const playButton = jQuery( '.video-button,.stat-collage__short-video' );

		playButton.on( 'click', togglePlayPause );
		function togglePlayPause() {
			if ( video[ 0 ].paused ) {
				video[ 0 ].play();
				setTimeout( function() {
			        playButton.hide();
			    }, 2000 );
			} else {
				video[ 0 ].pause();
			}
		}
		function stopVideo() {
			video[ 0 ].pause();
		}
	}

	jQuery( '.play-button-inner' ).click( function() {
		jQuery( '.video-button' ).toggleClass( 'play-icon' );
	} );

	const videoPlayer = document.getElementById( 'myVideo' );
	const stopButton = jQuery( '#stop-video' );
	stopButton.click( function() {
		videoPlayer.pause();
	} );

	/**
	 * Search Script
	 */
	if ( jQuery( window ).width() > 1003 ) {
		jQuery( document ).on( 'click focus', '.top-search', function() {
			jQuery( '.header-section' ).addClass( 'open' );
			jQuery( '#search-top .keyword' ).focus( );
		} );
		jQuery( '.search-close' ).on( 'focusout', function( e ) {
			jQuery( '.header-section' ).removeClass( 'open' );
			document.activeElement.blur();
		} );
		jQuery( '.search-close' ).on( 'click keypress', function( e ) {
			if ( e.which == 13 || e.which == 1 ) {
				setTimeout( () => {
					jQuery( '.header-section' ).removeClass( 'open' );
				}, 100 );
				document.activeElement.blur();
			}
		} );
	}
	    jQuery( '.chimp-filters__mobile' ).click( function() {
		jQuery( '.chimp-filters' ).slideToggle();
	} );
	if ( jQuery( window ).width() < 748 ) {
	 jQuery( '.page-template-template-toolkit-landing .donate-form__boxes-area__head' ).click( function() {
			jQuery( this ).next().slideToggle().css( 'display', 'flex' );
		} );
	}

	/**
	 * Add Class to section
	 */

	jQuery( '.donate-cta' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'over-flow-hidden' );
	jQuery( '.logo-grid' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'over-flow-hidden' );
	jQuery( '.event-teaser' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'over-flow-hidden' );

	jQuery( '.media-slider' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'over-flow-hidden' );
	jQuery( '.stat-collage' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'over-flow-hidden' );
	jQuery( '.blog-teaser' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'over-flow-hidden' );

	jQuery( '.image-gallery' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'over-flow-hidden' );
	jQuery( '.two-column-cta' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'over-flow-hidden' );
	jQuery( '.featured-text' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'over-flow-hidden' );
	jQuery( '.download-list' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'over-flow-hidden' );
	jQuery( '.third-party' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'over-flow-hidden' );
	jQuery( '.mid-page-cta.sattered' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'mid-page-cta-sattered-var' );
	jQuery( '.circular-cta' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'over-flow-hidden' );
	jQuery( '.donate-today.simple' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'donate-today-hand-simple' );
	jQuery( '.child-nav' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'sticky-nav' );
	jQuery( '.child-nav-list' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'sticky-nav' );
	jQuery( '.download-list.list' ).closest( '.wrapper' ).parent( 'section' ).removeClass( 'over-flow-hidden' );

	if ( jQuery( window ).width() > 1003 ) {
		jQuery( '.featured-text' ).closest( '.wrapper' ).parent( 'section' ).addClass( 'overflow-shape' );
	}

	/**
	 * Quote Video Script
	 */

	jQuery( 'a.video' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-fade',
		fixedContentPos: true,
		overflowY: 'hidden',

	} );
	/**
	 * Mac os
	 */
	if ( navigator.userAgent.indexOf( 'Mac OS X' ) !== -1 ) {
		if ( navigator.userAgent.indexOf( 'Chrome' ) !== -1 ) {
			// Add style for Chrome on Mac
			document.body.classList.add( 'style-for-window' );
		} else if ( navigator.userAgent.indexOf( 'Safari' ) !== -1 ) {
			// Add style for Safari on Mac
			document.body.classList.add( 'style-for-apple' );
		} else {
			// Add a generic style for other browsers on Mac
			document.body.classList.add( 'style-for-mac' );
		}
	} else {
		// Add style for other operating systems/Chrome on non-Mac
		document.body.classList.add( 'style-for-window' );
	}

	/**
	 * Border-Script
	 */
	function switchClasses() {
		const elements = jQuery( '.quiz-cta__single-img' );
		let currentClassIndex = 0;

		setInterval( function() {
			elements.removeClass( 'img-white-border ' );

			elements.eq( currentClassIndex ).addClass( 'img-white-border ' );

			currentClassIndex = ( currentClassIndex + 1 ) % elements.length;
		}, 2000 );
	}

	switchClasses();
	/**
	 *
	 * script for episode teaser
	 *
	 */

	jQuery( 'a.event-teaser__item' ).mouseenter( function() {
		jQuery( this ).addClass( 'hover-active' );
	} );

	jQuery( 'a.event-teaser__item' ).mouseleave( function() {
		jQuery( this ).removeClass( 'hover-active' );
		jQuery( this ).addClass( 'hover-deactive' );
		setTimeout( function() {
			jQuery( 'a.event-teaser__item' ).removeClass( 'hover-deactive' ).delay( 2000 );
		}, 5000 );
	} );
	/**
	 * Blog Teaser
	 */
	const owl = jQuery( '.blog-teaser__slider' );

	owl.owlCarousel( {
		margin: 20,
		dots: false,
		responsive: {
			0: { items: 1, margin: 10, stagePadding: 27 },
			600: { items: 2 },
			1180: { items: 3 },
		},
	} );

	if ( owl.find( '.owl-item' ).length > 4 ) {
		owl.trigger( 'destroy.owl.carousel' ).owlCarousel( { margin: 20, nav: true, dots: false, responsive: { 0: { items: 1, margin: 10, nav: false, stagePadding: 27 }, 600: { items: 2, nav: false }, 1004: { items: 3, nav: true } } } );
	}

	jQuery( '.media-slider__video-popup' ).magnificPopup( {
		type: 'inline',
		midClick: true,
		closeBtnInside: true,
		fixedContentPos: true,
		overflowY: 'hidden',
		callbacks: {
			beforeClose() {
				const videoElement = jQuery( this.content ).find( 'video' )[ 0 ];
				if ( videoElement && typeof videoElement.pause === 'function' ) {
					videoElement.pause();
					videoElement.currentTime = 0;
				}
			},
			beforeOpen() {
				const videoElement = jQuery( this.content ).find( 'video' )[ 0 ];
				if ( videoElement && typeof videoElement.play === 'function' ) {
					videoElement.muted = true;
					videoElement.play();
				}
			},
		},
	} );

	/**
	 * Instagram Slider
	 */

	jQuery( '.insta-slider' ).owlCarousel( {
		loop: true,
		margin: 20,
		nav: false,
		dots: false,
		autoplay: true,
		slideTransition: 'linear',
		autoplayTimeout: 4000,
		autoplaySpeed: 4000,
		mouseDrag: false,
		touchDrag: false,
		stagePadding: 89,
		responsive: {
			0: {
				items: 1,
				margin: 12,
				stagePadding: 97,

			},
			600: {
				items: 2,

			},
			1000: {
				items: 3,

			},
			1180: {
				items: 3,
			},
			1440: {
				items: 4,
			},
			1500: {
				items: 5,
			},

		},
	} );

	jQuery( document ).ready( function( $ ) {
		// Find the Instagram feed carousel element
		const instaSlider = jQuery( '#insta-slider' );
		// Customize transition properties
		const customCarouselArgs = {
			// Other existing properties...
			// Override transition properties
			slideTransition: 'ease', // Change to your desired transition type
			autoplayTimeout: 6000, // Change to your desired autoplay timeout
			autoplaySpeed: 600, // Change to your desired autoplay speed
			touchDrag: false,
			// Other existing properties...
		};
		// Merge the custom properties with the existing properties
		const mergedCarouselArgs = $.extend( {}, this.carouselArgs, customCarouselArgs );
		// Initialize the Owl Carousel with the modified properties
		instaSlider.owlCarousel( mergedCarouselArgs );
	} );

	/**
	 * Stats
	 */
	jQuery(
		( function( jQuery, win ) {
			jQuery.fn.inViewport = function( cb ) {
				return this.each( function( i, el ) {
					function visPx() {
						const H = jQuery( this ).height(),
							r = el.getBoundingClientRect(),
							t = r.top,
							b = r.bottom;
						return cb.call(
							el,
							Math.max( 0, t > 0 ? H - t : b < H ? b : H )
						);
					}
					visPx();
					jQuery( win ).on( 'resize scroll', visPx );
				} );
			};
		} )( jQuery, window )
	);
	jQuery( '.stat-number,.stats__value' ).inViewport( function( px ) {
		if ( px > 0 && ! this.initNumAnim ) {
			this.initNumAnim = true;
			const $this = jQuery( this ),
				countTo = $this.attr( 'data-number' );
			const startValue = countTo / 2; // Set the start value to 50% of the given value
			jQuery( {
				countNum: startValue,
			} ).animate( {
				countNum: countTo,
			}, {
				duration: 1500,
				easing: 'swing',
				step() {
					// $this.text(Math.ceil(this.countNum));   showing commas during counter running
					$this.text(
						Math.ceil( this.countNum ).toLocaleString( 'en' )
					);
				},
				complete() {
					$this.text(
						Math.ceil( this.countNum ).toLocaleString( 'en' )
					);
				},
			} );
		}
	} );
	/**
	 * Search
	 */
	// Toggle the 'open' class when clicking on an element with the class 'top-search'
	jQuery( '.top-search' ).click( function() {
		jQuery( '.search-form-new' ).toggleClass( 'open' );
	} );
	/**
	 * Shuffle
	 */
	jQuery( '.chimp-teaser-shuffle-btn' ).click( function() {
		jQuery( '.chimp-teaser-shuffle-btn' ).toggleClass( 'new-shape' );
		jQuery( '.chimp-teaser__items__list' ).toggleClass( 'new-items' );
	} );
	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.chimp-teaser-shuffle-btn' ).click( function() {
			jQuery( '.chimp-teaser__items__list' ).toggleClass( 'new-items' );
		} );
	}

	// Remove the 'open' class when clicking on an element with the class 'search-close'
	jQuery( '.search-close,.menu-btn' ).click( function() {
		jQuery( '.search-form-new' ).removeClass( 'open' );
	} );

	// Your existing code for the menu button click event
	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );

	// Prevent body click event from being triggered when clicking on the menu button
	jQuery( '.menu-btn' ).on( 'click', function( event ) {
		event.stopPropagation();
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	if ( jQuery( window ).width() > 1179 ) {
		jQuery( '.menu-item-has-children' ).hover(
			function() {
				jQuery( 'body' ).addClass( 'body-hovered' );
			},
			function() {
				jQuery( 'body' ).removeClass( 'body-hovered' );
			}
		);

		/**
		 * Toggle menu for mobile
		 */
		// accessible sub menu
		jQuery( '.menu-item-has-children > a' ).focus( function() {
			jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
			jQuery( 'body' ).addClass( 'body-hovered' );
		} ).blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
			jQuery( 'body' ).removeClass( 'body-hovered' );
		} );

		// For children.
		jQuery( '.sub-menu a' ).focus( function() {
			jQuery( 'body' ).addClass( 'body-hovered' );
			jQuery( this ).parents( '.sub-menu' ).addClass( 'focused' );
		} ).blur( function() {
			jQuery( this ).parents( '.sub-menu' ).removeClass( 'focused' );
			jQuery( 'body' ).removeClass( 'body-hovered' );
		} );

		jQuery( '.menu-item-has-children > a' ).each( function() {
			jQuery( this ).focus( function() {
				jQuery( 'body' ).addClass( 'body-hovered' );
				jQuery( this ).siblings( '.mega-menu' ).addClass( 'focused' );
			} );
			jQuery( this ).blur( function() {
				jQuery( this ).siblings( '.mega-menu' ).removeClass( 'focused' );
				jQuery( 'body' ).removeClass( 'body-hovered' );
			} );
		} );

		// For children.
		jQuery( '.mega-menu a' ).focus( function() {
			jQuery( 'body' ).addClass( 'body-hovered' );
			jQuery( this ).parents( '.mega-menu' ).addClass( 'focused' );
		} ).blur( function() {
			jQuery( this ).parents( '.mega-menu' ).removeClass( 'focused' );
			jQuery( 'body' ).removeClass( 'body-hovered' );
		} );

		jQuery( 'li.menu-item-has-children' ).each( function() {
			if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
				const anchor = jQuery( this ).find( 'a:first' );
				anchor.append( '<span class="submenu-icon"></span>' );
			}
		} );
	}
	if ( jQuery( window ).width() < 1179 ) {
		jQuery( 'li.menu-item-has-children' ).each( function() {
			if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
				const anchor = jQuery( this ).find( 'a:first' );
				anchor.append( '<span class="submenu-icon"></span>' );
			}
		} );
	}

	// Style Variations.
	const modeOptions = jQuery( 'input[name="mode"]' );
	const body = jQuery( 'body' );

	// Function to update the mode based on the selected radio button
	function updateMode() {
		const selectedMode = modeOptions.filter( ':checked' ).attr( 'id' );

		body.removeClass( 'dark-mode light-dark-mode high-contrast-mode' );

		if ( selectedMode === 'dark-mode' ) {
			body.addClass( 'dark-mode' );
			localStorage.setItem( 'mode', 'dark-mode' );
		} else if ( selectedMode === 'light-dark-mode' ) {
			body.addClass( 'light-dark-mode' );
			localStorage.setItem( 'mode', 'light-dark-mode' );
		} else if ( selectedMode === 'high-contrast-mode' ) {
			body.addClass( 'high-contrast-mode' );
			localStorage.setItem( 'mode', 'high-contrast-mode' );
		} else {
			// Default to light mode if no radio button is selected
			body.addClass( 'light-mode' );
			localStorage.setItem( 'mode', 'light-mode' );
		}
	}

	// Check local storage for user preference
	const userPreference = localStorage.getItem( 'mode' );
	if ( userPreference ) {
		modeOptions.filter( `#${ userPreference }` ).prop( 'checked', true );
		updateMode();
	}

	// Handle radio button change events
	modeOptions.change( updateMode );
} );

jQuery( document ).ready( function() {
	const isiDevice = / iPod| iPad| iPhone/i.test( navigator.userAgent.toLowerCase() );

	 if ( isiDevice ) {
	    jQuery( 'body' ).addClass( 'is_i_device' );
	}

	  jQuery( '.select-dropdown__button' ).on( 'click', function() {
		const dropdown = jQuery( this ).closest( '.select-dropdown' );
		dropdown.find( '.select-dropdown__button' ).toggleClass( 'is-button-opened' );
		dropdown.find( '.select-dropdown__list' ).toggleClass( 'is-active-dropdown' );
	} );
	if ( jQuery( window ).width() > 1003 ) {
	 // Replace 'first-target-class' and 'second-target-class' with the classes you are looking for
		if ( jQuery( 'body' ).find( '.sticky-nav' ).length > 0 || jQuery( 'body' ).find( '.nav-list' ).length > 0 ) {
		// Replace 'new-class-to-add' with the class you want to add
			jQuery( 'body' ).addClass( 'has-sticky' );
		}
	}
	 jQuery( 'blockquote' ).each( function() {
		if ( jQuery( this ).find( 'p img' ).length > 0 ) {
			jQuery( this ).addClass( 'has-image' );
		}
	} );

	/*
   * Close popup on anywhere click
   */
	jQuery( document ).mouseup( function( e ) {
		// const container = jQuery( '.select-dropdown__list' );
		const dropdowns = jQuery( '.select-dropdown' );
		dropdowns.each( function() {
			const dropdown = jQuery( this );
			const button = dropdown.find( '.select-dropdown__button' );
			const list = dropdown.find( '.select-dropdown__list' );
			if ( ! list.is( e.target ) && list.has( e.target ).length === 0 && ! button.is( e.target ) && button.has( e.target ).length === 0 ) {
				list.removeClass( 'is-active-dropdown' );
				button.removeClass( 'is-button-opened' );
			}
		} );
	} );
	jQuery( '.select-dropdown__sort-item' ).on( 'click', function() {
		const ratioText = 'Ratio';
		const itemValue = jQuery( this ).children().find( '.select-dropdown__inner-title' ).data( ratioText );
		jQuery( this ).addClass( 'active-list' ).siblings().removeClass( 'active-list' );
		jQuery( this ).parents( '.select-dropdown' ).find( '.select-dropdown__button span.dd-selected-value' ).text( jQuery( this ).text() ).parents().attr( 'data-value', itemValue );
		jQuery( this ).parents( '.select-dropdown' ).find( '.select-dropdown__list' ).removeClass( 'is-active-dropdown' );
		jQuery( this ).parents( '.select-dropdown' ).find( '.select-dropdown__button.is-button-opened' ).removeClass( 'is-button-opened' );
	} );

	/*
   * Blog page filter Script
   */

	jQuery( '.category-nav-inner .select-dropdown__button' ).on( 'click', function() {
		const dropdown = jQuery( this ).closest( '.select-dropdown' );
		dropdown.find( 'category-nav-inner .select-dropdown__button' ).toggleClass( 'is-button-opened' );
		dropdown
			.find( '.select-dropdown__list' )
			.toggleClass( 'is-active-dropdown' );
	} );
	jQuery( '.category-nav-inner .dropdown-list-title' ).on( 'click', function() {
		const dropdown = jQuery( this ).closest( '.select-dropdown' );
		dropdown
			.find( '.select-dropdown__button' )
			.toggleClass( 'is-button-opened' );
		dropdown
			.find( '.select-dropdown__list' )
			.toggleClass( 'is-active-dropdown' );
	} );
	jQuery( '.category-nav-inner .dropdown-list-title' ).on( 'click', function() {
		const ratioText = 'Ratio';
		const itemValue = jQuery( this ).data( ratioText );
		jQuery( this )
			.parents( '.select-dropdown' )
			.find( '.select-dropdown__button' )
			.text( jQuery( this ).text() )
			.parents()
			.attr( 'data-value', itemValue );
	} );

	/**
	 * Virtual Tour
	 */
	// const virtualVideoPlayer = document.getElementById( 'virtual-tour-video' );
	// const virtualStopButton = document.getElementById( 'virtual-model-close' );

	jQuery( '.virtual-model-close' ).click( function() {
		jQuery( '.virtual-model video' ).trigger( 'pause' );
		jQuery( '.virtual-model video' )[ 0 ].currentTime = 0;
	} );

	jQuery( 'a.video' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-fade',
		fixedContentPos: true,
		overflowY: 'hidden',
	} );
	jQuery( '.search-close' ).on( 'click', function() {
		jQuery( '.keyword' ).val( '' );
	} );
} );

jQuery( document ).mouseup( function( e ) {
	const container = jQuery( '.virtual-model' );
	// if the target of the click isn't the container nor a descendant of the container
	if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
		jQuery( '.virtual-model' ).removeClass( 'active' );
	}
} );
jQuery.noConflict();

jQuery( document ).ready( function() {
	if ( jQuery( window ).width() < 1180 ) {
		jQuery( '.menu-item-has-children .main-menu-link' ).click( function( e ) {
			e.preventDefault(); // Prevent the default link behavior
			const megaMenu = jQuery( this ).parent().find( '.mega-menu' );
			const subMenu = jQuery( this ).parent().find( '.sub-menu' );

			jQuery( '.mega-menu' ).slideUp();
			jQuery( '.sub-menu' ).slideUp();

			megaMenu.slideDown();
			subMenu.slideDown();
		} );

		// Add this click event to close mega menu when clicking anywhere else on the page
		// jQuery( document ).on( 'click', function( e ) {
		// 	if ( ! jQuery( e.target ).closest( '.menu-item-object-mega-menu-1' ).length ) {
		// 		jQuery( '.mega-menu' ).slideUp();
		// 	}
		// } );

		// Selecting elements based on your criteria
		const menuLinks = jQuery( '.menu-item-has-children:not(.menu-item-object-mega-menu-1)' );
		//  const mainMenuLink = menuLinks;

		// Looping through each selected element
		menuLinks.each( function() {
			    // Getting the href attribute and text value
			    const hrefValue = jQuery( this ).find( 'a.main-menu-link' ).attr( 'href' );
			    const textValue = jQuery( this ).find( 'a.main-menu-link' ).text();

			jQuery( this ).find( 'a.main-menu-link' ).siblings( 'ul.sub-menu' ).append( "<div class='mega-menu__right--button'><a href='" + hrefValue + "' class='button mega-menu-btn thisisButton' target=''>" + textValue + '</a></div>' );

			    // Outputting the values (you can modify this part based on your requirements)
			    // console.log( 'Href: ' + hrefValue + ', Text: ' + textValue );
		} );
	}

	// Donation Form Code Start.
	const myInterval = setInterval( () => {
		if ( jQuery( '.donate-form-box' ).find( 'form' ).length > 0 ) {
			jQuery( '.at-credit-card-button-wrapper label' ).text( 'Card' );
			jQuery( '.at-eft-button-wrapper label' ).text( 'Bank Account' );
			jQuery( '.at-paypal-button' ).text( 'Paypal' );

			jQuery( '.form-item-inhonororinmemoryof .radios .at-radio-label-2' ).addClass( 'highlight' );

			jQuery( '.form-item-selectedfrequency .radios .at-radio-label-0' ).addClass( 'highlight' );

			setTimeout( () => {
				jQuery( '.label-amount' ).each( function() {
					const labelText = jQuery( this ).attr( 'title' );

					if ( labelText.includes( 'US' ) ) {
						const updatedText = labelText.replace( 'US', '' );
						const labelHTML = jQuery( this ).html().replace( 'US', '' );
						jQuery( this ).attr( 'title', updatedText );
						jQuery( this ).html( labelHTML );
					}
				} );
				jQuery( '.at-form-submit' ).find( 'input[type="submit"]' ).val( jQuery( '.at-form-submit' ).find( 'input[type="submit"]' ).val().replace( 'US', '' ) );

				// Form Selected Value came from BLock.
				let donateValue = '';
				const urlParams = new URLSearchParams( window.location.search );

				if ( urlParams.has( 'donate' ) ) {
					donateValue = urlParams.get( 'donate' );
					jQuery( 'html, body' ).animate( {
						scrollTop: jQuery( '.donate-form-box' ).offset().top - 180,
					}, 10 );
				}
				const labelAmounts = [];

				jQuery( '.label-amount' ).each( function() {
					const labelText = jQuery( this ).attr( 'title' );
					if ( labelText === donateValue ) {
						jQuery( '.label-otheramount' ).siblings( '.label-amount' ).removeClass( 'highlight' );
						jQuery( this ).addClass( 'highlight' );
						jQuery( this ).find( 'input[type="radio"]' ).prop( 'checked', true );
					}
					labelAmounts.push( labelText );
				} );
				if ( jQuery.inArray( donateValue, labelAmounts ) === -1 ) {
					jQuery( '.label-otheramount' ).siblings( '.label-amount' ).removeClass( 'highlight' );
					jQuery( '.label-otheramount' ).find( 'input[type="number"]' ).val( parseFloat( donateValue.replace( '$', '' ) ) );
					jQuery( '.label-otheramount' ).find( 'input[type="number"]' ).focus();
				}
				jQuery( '.label-otheramount' ).find( 'input[type="number"]' ).on( 'change keypress', function() {
					jQuery( this ).parent().siblings( '.label-amount' ).removeClass( 'highlight' );
				} );

				jQuery( '.radios' ).find( 'input[type="radio"]' ).change( function() {
					if ( jQuery( this ).is( ':checked' ) ) {
						jQuery( this ).parent().parent().find( 'label' ).removeClass( 'highlight' );
						jQuery( this ).parent( 'label' ).addClass( 'highlight' );
					} else {
						jQuery( this ).parent( 'label' ).removeClass( 'highlight' );
					}

					setTimeout( () => {
						jQuery( '.label-amount' ).each( function() {
							const labelText = jQuery( this ).attr( 'title' );

							if ( labelText.includes( 'US' ) ) {
								const updatedText = labelText.replace( 'US', '' );
								const labelHTML = jQuery( this ).html().replace( 'US', '' );
								jQuery( this ).attr( 'title', updatedText );
								jQuery( this ).html( labelHTML );
							}
						} );
						jQuery( '.label-otheramount' ).find( 'input[type="number"]' ).on( 'change keypress', function() {
							jQuery( this ).parent().siblings( '.label-amount' ).removeClass( 'highlight' );
						} );
						jQuery( '.at-form-submit' ).find( 'input[type="submit"]' ).val( jQuery( '.at-form-submit' ).find( 'input[type="submit"]' ).val().replace( 'US', '' ) );
						jQuery( '.at-radios' ).find( 'input[type="radio"]' ).each( function() {
							if ( jQuery( this ).is( ':checked' ) ) {
								jQuery( this ).parent( 'label' ).addClass( 'highlight' );
							} else {
								jQuery( this ).parent( 'label' ).removeClass( 'highlight' );
							}
						} );
						jQuery( '.at-radios' ).find( 'input[type="radio"]' ).change( function() {
							if ( jQuery( this ).is( ':checked' ) ) {
								jQuery( this ).parent().parent().find( 'label' ).removeClass( 'highlight' );
								jQuery( this ).parent( 'label' ).addClass( 'highlight' );
							} else {
								jQuery( this ).parent( 'label' ).removeClass( 'highlight' );
							}
						} );
					}, 100 );
				} );
				jQuery( '.at-radios' ).find( 'input[type="radio"]' ).change( function() {
					if ( jQuery( this ).is( ':checked' ) ) {
						jQuery( this ).parent().parent().find( 'label' ).removeClass( 'highlight' );
						jQuery( this ).parent( 'label' ).addClass( 'highlight' );
					} else {
						jQuery( this ).parent( 'label' ).removeClass( 'highlight' );
					}
				} );

				// jQuery( '#creditcard_radio_1737287' ).prop( 'checked', true );
				jQuery( 'input[type="radio"]' ).each( function() {
					if ( jQuery( this ).is( ':checked' ) ) {
						jQuery( this ).parent( 'label' ).addClass( 'highlight' );
					} else {
						jQuery( this ).parent( 'label' ).removeClass( 'highlight' );
					}
				} );

				jQuery( '.PaymentInformation' ).slideDown();
				jQuery( '.AdditionalInformation' ).slideDown();
				jQuery( '.ContactInformation' ).slideDown();
				jQuery( '.at-form-submit input' ).show();
			}, 100 );
			clearInterval( myInterval );
		}
	}, 100 );
	// Donation Form Code End.

	// Click event for opening the modal
	jQuery( '.friend-modal' ).click( function( event ) {
		event.stopPropagation(); // Prevents the click event from reaching the document
		jQuery( '.became-friend-modal' ).addClass( 'show-popup' );
		jQuery( 'body' ).addClass( 'popup-shadow' );
		jQuery( 'html' ).addClass( 'popup-scroll-hide' );
	} );

	// Click event for closing the modal
	jQuery( '.popup-close-button' ).click( function( event ) {
		event.stopPropagation(); // Prevents the click event from reaching the document
		jQuery( '.became-friend-modal' ).removeClass( 'show-popup' );
		jQuery( 'body' ).removeClass( 'popup-shadow' );
		jQuery( 'html' ).removeClass( 'popup-scroll-hide' );
	} );

	// Click event to close the modal when clicking outside of it
	jQuery( document ).click( function() {
		jQuery( '.became-friend-modal' ).removeClass( 'show-popup' );
		jQuery( 'body' ).removeClass( 'popup-shadow' );
		jQuery( 'html' ).removeClass( 'popup-scroll-hide' );
	} );

	// Prevents the click event on the modal from reaching the document
	jQuery( '.became-friend-modal' ).click( function( event ) {
		event.stopPropagation();
	} );
} );

jQuery( document ).ready( function() {
	let visibleItemCount = 12;

	function showNextItems() {
		const totalItemCount = jQuery( '.third-party-link__images.logos .third-party-link__single' ).length;
		const remainingItemCount = totalItemCount - visibleItemCount;

		const $itemsToDisplay = jQuery( '.third-party-link__images.logos .third-party-link__single:lt(' + ( visibleItemCount + Math.min( 12, remainingItemCount ) ) + '):gt(' + ( visibleItemCount - 1 ) + ')' );
		$itemsToDisplay.css( 'display', 'block' );

		visibleItemCount += Math.min( 12, remainingItemCount );

		if ( visibleItemCount >= totalItemCount ) {
			jQuery( '.third-party__button' ).hide();
		}
	}

	jQuery( '.third-party-link__images.logos .third-party-link__single:gt(' + ( visibleItemCount - 1 ) + ')' ).css( 'display', 'none' );

	jQuery( '.third-party__button a' ).on( 'click', function( e ) {
		e.preventDefault();
		showNextItems();
	} );

	jQuery( document ).on( 'keypress', '.faq-heading', function( e ) {
		if ( e.which == 13 ) {
			jQuery( this ).click();
		}
	} );
} );
